import { render, staticRenderFns } from "./HistoryDatatable.vue?vue&type=template&id=5d274cde"
import script from "./HistoryDatatable.vue?vue&type=script&lang=js"
export * from "./HistoryDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports